import React, { useRef, useState } from 'react';
import './forgot-password.styles.scss';
import { Link, useNavigate } from 'react-router-dom';
import UIkit from 'uikit';
import { UseCloudFunction } from '@/firebase-utils/firebase.utils';
import ThreeDotsLoader from '../loader/three-dots-loader.component';

const ForgotPasswordPage = () => {

    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ loading, setLoading ] = useState(false);
    const navigate = useNavigate();
    const approveRef = useRef();

    async function sendResetLink() {
        const email = document.getElementById('email').value.toLowerCase().replace(/\s+/g, '');
        console.log(email);
        if (!email.includes('@') || !email.includes('.')) {
            UIkit.modal.alert('Please enter a valid email address.');
            return;
        }
        setLoading(true);
        const res = await UseCloudFunction(
            'sendPasswordResetEmail',
            { 'userEmail': email }
        )
        console.log(res);
        setLoading(false);
        if (res.error) {
            UIkit.modal.alert(`Something went wrong. Please try again. (Error: ${res.error})`);
            return;
        }
        UIkit.modal.alert('Password reset link sent to your email address. ' + 
            'It could take a couple of minutes for you to receive it. Please check your inbox.');
        approveRef.current = () => {
            navigate('/signin')
        }
    }

    return (
        <div className='forgot-password-page'>
            <div className='forgot-password-page__container g-box'>
                    <h3>Forgot Password</h3>
                    <hr />
                    <p>Enter your email address to reset your password.</p>
                    <div className='field small'>
                        <input 
                            className='uk-input'
                            type='email' 
                            id='email' 
                            name='email'
                            placeholder='your-email@email.com...' 
                            required />
                    </div>
                    <div className="g-space-1"></div>
                    {
                        (loading) 
                        ?
                        <div className='buttons'>
                            <button 
                                className='g-button'>
                                Cancel
                            </button>
                            <button className='g-button'>
                                <ThreeDotsLoader />
                            </button>
                        </div>
                        :
                        <div className='buttons'>
                            <Link to='/signin'>
                                <button 
                                    className='g-button'>
                                    Cancel
                                </button>
                            </Link>
                            <button 
                                className='g-button primary'
                                onClick={() => sendResetLink()} >
                                Send Reset Link
                            </button>
                        </div>
                    }
                </div>
        </div>
    )
}

export default ForgotPasswordPage